import { render, staticRenderFns } from "./hwxxfbDetail.vue?vue&type=template&id=9ddf178a&scoped=true"
import script from "./hwxxfbDetail.vue?vue&type=script&lang=js"
export * from "./hwxxfbDetail.vue?vue&type=script&lang=js"
import style0 from "./hwxxfbDetail.vue?vue&type=style&index=0&id=9ddf178a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddf178a",
  null
  
)

export default component.exports